<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied" class="row">
    <div class="col-xl-12 ">
        <div class="row">
            <div class="col-xl-12">
                <div class="row" style="margin-bottom: 15px;">
                    <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
                        <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                            <span style="float:left">Submit new internal request</span>
                        </h6>
                    </div>
                    <div class="col-xl-12 block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
                        <div class="col-md-12 col-sm-12 ">

                            <div class="row small-section-content" style="margin-bottom:20px">
                                <div class="col-xl-12 text-center empty">
                                    <p style="text-align: left;padding-top: 10px;">Your thoughts are important to us!</p>
                                    <p style="text-align: left;padding-top: 5px;">Help us improve the quality of our services by sending your feedback or complaint. Our team will review your message and will get back to you shortly.</p>
                                    <p style="text-align: left;padding-top: 5px;">For urgent concerns please call us at +971 6 575 0055.</p>
                                </div>
                            </div>

                            <div class="col-md-12 col-sm-12 col-xs-12 b20-margin no-padding r20-padding l20-padding t30-padding b20-padding myG-box">
                                <div class="col-md-12 col-sm-12 col-xs-12 no-padding ">

                                    <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                                        <div class="form-floating">
                                            <select class="form-select" id="floatingSelect" aria-label="Floating label select example" (change)="selectCategoryOption($event)">

                                                <option *ngFor="let category of internalRequestCategories" [value]="category.categoryCode">
                                                    {{ category.categoryName}}
                                                </option>
                                            </select>
                                            <label for="floatingSelect">Category</label>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                                        <div class="form-floating">
                                            <input type="text" class="form-control" id="floatingInputValueSubject" [(ngModel)]="userRequest.subject">
                                            <label for="floatingInputValueSubject">Subject</label>
                                        </div>

                                    </div>
                                    <div class="form-group col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom:20px">
                                        <p style="margin:0px">
                                            <small>{{descriptionCategoryLabel}}</small>
                                        </p>
                                        <div class="form-floating">
                                            <textarea style="height:150px" [(ngModel)]="userRequest.description" class="form-control" placeholder="Leave your description here..." id="floatingTextareaDescription"></textarea>
                                            <label for="floatingTextareaDescription">Description</label>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                                        <div class="form-floating">
                                            <select class="form-select" id="floatingSelect" aria-label="Floating label select example" (change)="selectSourceOption($event)">

                                                <option *ngFor="let source of internalRequestSources" [value]="source.sourceCode">
                                                    {{ source.sourceName}}
                                                </option>
                                            </select>
                                            <label for="floatingSelect">Source</label>
                                        </div>
                                    </div>


                                    <div class="form-group col-md-12 col-sm-12 col-xs-12 no-padding">
                                        <button [disabled]="btnVerifyDisabled" style="float: right;" class="btn mygistec-main-btn" (click)="addRequest()">{{btnVerifyText}}</button>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

